import type { ReactNode } from "react";
import Box from "@mui/material/Box";
import type { SxProps, Theme } from "@mui/material/styles";

interface WebhookLogListTemplateProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

/** The grid every webhook log row (and its header) is laid out on; cells place themselves by gridArea name. */
export const WebhookLogListTemplate = (props: WebhookLogListTemplateProps) => {
  const { children, sx } = props;

  return (
    <Box
      sx={{
        alignItems: "center",
        columnGap: 2,
        display: "grid",
        gridTemplateAreas: `'received source event outcome error replay'`,
        gridTemplateColumns: "170px 80px 1fr 110px 2fr 110px",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
